import { Css } from "@homebound/beam";

export const weightedStyle = Css.fw(600).$;
